import { SET_ALL_MENU_LIST, SET_MENU_DETAILS } from "../../common/constants/ActionTypes"

const initialState = { 
    errorMessage: "",
    allMenuList: [],
    menuDetails:{},
}

export default function manageMenuReducer(state = initialState, action) {
    switch(action.type) {
        case SET_ALL_MENU_LIST: 
            return {
                ...state,
                allMenuList : action.payload
            }
        case SET_MENU_DETAILS: 
            return {
                ...state,
                menuDetails : action.payload
            }
        
        default:
            return state;
    }
}